import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "flag-icons-vn",
  viewBox: "0 0 640 480"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"vn-a\"><path fill-opacity=\".7\" d=\"M-85.3 0h682.6v512H-85.3z\"></path></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#vn-a)\" transform=\"translate(80)scale(.9375)\"><path fill=\"#da251d\" d=\"M-128 0h768v512h-768z\"></path><path fill=\"#ff0\" d=\"M349.6 381 260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }